import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ logoUrl = '/snox-logo.png' }) => {
    return (
        <header className="site-header">
            <div className="container header-container">
                <div className="logo">
                    <Link to="/">
                        <img src={logoUrl} alt="Snox" />
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Header;